<template>
    <div class="card">
      <div class="card-body tw:p-3">
        <div class="tw:flex tw:items-start tw:gap-3">
          <Mail class="tw:size-5 tw:mt-0.5 tw:flex-shrink-0" />
          <div class="tw:flex-1">
            <h3 class="tw:text-base tw:mb-0">{{ $t('Message') }}</h3>
            <form v-on:submit.prevent="sendRequest()" class="tw:space-y-2 tw:mt-2">
              <Alert class="tw:mb-2" variant="success" v-if="success">{{ $t('Message sent successfully.') }}</Alert>
              <Alert class="tw:mb-2" variant="danger" v-if="errors.length > 0 && !success">
                {{ errors }}
              </Alert>

              <div>
                <label for="message-id" class="col-form-label tw:block tw:!pt-0">{{ $t('Select a message') }}</label>
                <select name="" id="message-id" class="form-control"  v-model="messageId">
                  <option v-for="msg in messages" :value="msg.id">
                    {{ msg.name }}
                  </option>
                </select>
              </div>

              <button type="submit" class="btn btn-primary" :disabled="!messageId || disableButton">
                {{ $t('Send') }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import Alert from "@/components/ui/Alert.vue";
    import { Mail } from "@lucide/vue";

    export default {
        name: "SendMarketingMessage",
      components: {Alert, Mail},
        props: {
            productTest : {
                required: true,
            },
            messages : {
                type : Array
            },
        },
        data() {
            return {
                messageId : null,
                errors: [],
                success: false,
                disableButton: false,
            }
        },
        methods: {
            sendRequest : function() {
                var vm = this;
                vm.disableButton = true;
                var message = this.messages.find( message => message.id === this.messageId);
                axios.post(message.links.sendProductReviewRequest, {
                    message_id : this.messageId,
                    product_test_id : this.productTest.id,
                })
                    .then(function(response) {
                        vm.success = true;
                        vm.$emit('send');
                    }).catch(function (error) {
                        vm.success = false;
                        vm.errors = error.response.data.errors
                    }).finally(function () {
                        vm.disableButton = false
                    })
            }
        },
        mounted() {
            if(this.messages.length > 0) {
                this.messageId = this.messages[0].id;
            }
        }
    }
</script>

<style scoped>

</style>
